exports.isSendKey = (event) => (event.key === 'Enter' || event.code === 'Enter') && !event.shiftKey
    && !event.isComposing && !event.nativeEvent?.isComposing && event.keyCode !== 229;
